export const accessTokenLink = {
  'AZURE'   : 'https://learn.microsoft.com/en-us/azure/devops/organizations/accounts/use-personal-access-tokens-to-authenticate?view=azure-devops&tabs=Windows',
  'GIT_LAB' : 'https://docs.gitlab.com/ee/user/profile/personal_access_tokens.html#create-a-personal-access-token',
  'GIT_HUB' : 'https://docs.github.com/en/authentication/keeping-your-account-and-data-secure/creating-a-personal-access-token'
};
export function showMsg(msg: string, type: string) {
  return { show: true, caption: msg, type: type };
}

export function hideMsg() {
  return { show: false, caption: '', type: '' };
}

export function formatCommitMsg(template: string, fileNames: string[]): string {
  if (fileNames.length > 0) {
    return template.replace('${0}', fileNames.join(', '));
  }
  return '';
}

export function isEmailType(username: string | string[]) {
  return (username && username.indexOf('@') > -1) || false;
}
